import React, { useEffect, useState } from 'react';
import { Button, Row, Col, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { actionClearCockpitInfo } from '@/redux/action';
import {
  CockpitStatus,
  CockpitMode,
  AcceptIssueStatus,
  CLSTAG,
} from '@/utils/constant';
import SelectMode from '@/views/ChooseCockpit/components/SelectMode';
import { RootState } from '../../../../redux/store';
import classNames from 'classnames';
import { Avatar, Vertical } from '@/components/CockpitBoardHeader';
import { clstagStr, transCockpitWorkTime } from '@/utils/util';
import { ChangeCockpitStatus } from '@/fetch/bussiness/ChangeCockpitStatus';
import './index.scss';
import { HttpStatusCode } from '@/fetch/core/constant';
import { showMsg } from '@/utils/util';
import { sendGlobalEvent } from '@/utils/emit';
import { useLocation, useNavigate } from 'react-router-dom';
import ActionType, { actionSendSocketData } from '@/redux/action/common';
import { showModal } from '@/components/Common/Modal';

const SwitchBoard = ({
  show,
  changeSwitchBoardShow,
}: {
  show: boolean;
  changeSwitchBoardShow: AnyFunc;
}) => {
  const cockpitModeMap = new Map([
    [CockpitMode.LISTENING_MODE, '听单模式'],
    [CockpitMode.WATCH_CAR_MODE, '盯车模式'],
    [CockpitMode.PATROL_MODE, '巡查模式'],
  ]);
  const navigator = useNavigate();
  const dispatch = useDispatch();
  const { cockpitMode, cockpitStatus, currentCockpit, acceptIssueStatus } =
    useSelector((state: RootState) => state.cockpitInfo);
  const { issueList } = useSelector((state: RootState) => state.workOrder);
  const { userName } = useSelector((state: RootState) => state.login);
  const cockpitStatusApi = new ChangeCockpitStatus();
  const [totalWorkTime, setTotalWorkTime] = useState<string>('');
  const [changeStatusBtnTitle, setChangeStatusBtnTitle] = useState<any>({
    title: '',
    nextStatus: null,
    nextAccept: null,
    clstag: clstagStr(CLSTAG.Rest),
  });
  const [isHover, setIsHover] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('click', () => {
      changeSwitchBoardShow();
    });
    const timeInterval = setInterval(() => {
      calculateWorkTime();
    }, 60000);
    return () => {
      window.removeEventListener('click', () => {});
      clearInterval(timeInterval);
    };
  }, []);

  useEffect(() => {
    calculateWorkTime();
  }, [currentCockpit.individualStartTime, currentCockpit.individualWorkTime]);

  useEffect(() => {
    formatChangeStatusBtnTitle();
  }, [issueList && issueList.length, acceptIssueStatus]);

  const calculateWorkTime = () => {
    if (!currentCockpit.individualStartTime) {
      setTotalWorkTime(transCockpitWorkTime(currentCockpit.individualWorkTime));
      return;
    }
    const now = new Date().getTime();
    const _totalWorkTime = transCockpitWorkTime(
      now -
        currentCockpit.individualStartTime +
        currentCockpit.individualWorkTime,
    );
    setTotalWorkTime(_totalWorkTime);
  };

  const formatChangeStatusBtnTitle = () => {
    if (cockpitStatus === CockpitStatus.REST) {
      setChangeStatusBtnTitle({
        title: '工作',
        nextAccept: AcceptIssueStatus.ACCEPT,
        nextStatus: CockpitStatus.WORK,
        clstag: clstagStr(CLSTAG.Work),
      });
      return;
    }
    if (issueList && issueList.length > 0) {
      if (acceptIssueStatus === AcceptIssueStatus.ACCEPT) {
        setChangeStatusBtnTitle({
          title: '结单后休息',
          nextAccept: AcceptIssueStatus.STOP,
          nextStatus: CockpitStatus.WORK,
          clstag: clstagStr(CLSTAG.CompleteThenRest),
        });
      } else {
        setChangeStatusBtnTitle({
          title: '取消',
          nextAccept: AcceptIssueStatus.ACCEPT,
          nextStatus: CockpitStatus.WORK,
        });
      }
    } else {
      setChangeStatusBtnTitle({
        title: '休息',
        nextAccept: AcceptIssueStatus.STOP,
        nextStatus: CockpitStatus.REST,
        clstag: clstagStr(CLSTAG.Rest),
      });
    }
  };
  const handleChangeMode = async (val: CockpitMode) => {
    const res = await cockpitStatusApi.changeCockpitMode(
      val,
      currentCockpit.cockpitNumber,
    );
    if (res.code === HttpStatusCode.Success) {
      showMsg({
        msg: `成功切换至${cockpitModeMap.get(val)}模式`,
        type: 'success',
      });
      if (val === CockpitMode.PATROL_MODE) {
        navigator('/app/patrolMode');
      } else {
        navigator('/app/realtime');
      }
    } else {
      showMsg({
        msg: res.message,
        type: 'error',
      });
    }
  };

  const handleQuitCockpit = async () => {
    const res = await cockpitStatusApi.quitCockpit();
    if (res.code === HttpStatusCode.Success) {
      sendGlobalEvent('CLOSE_MQTT_CLIENT');
      if (window.location.pathname === '/app/realtime') {
        window.location.reload();
      } else {
        navigator('/app/realtime');
      }
      dispatch(actionClearCockpitInfo());
      changeSwitchBoardShow();
    }
    showMsg({
      msg: res.code === HttpStatusCode.Success ? '退出座席成功' : res.message,
      type: res.code === HttpStatusCode.Success ? 'success' : 'error',
    });
  };

  const changeBtnHover = (val: boolean) => {
    setIsHover(val);
  };

  const changeStatus = async () => {
    try {
      const res = await cockpitStatusApi.changeCockpitStatus(
        changeStatusBtnTitle.nextStatus,
        currentCockpit.cockpitNumber,
        changeStatusBtnTitle.nextAccept,
      );
      if (
        res?.code === HttpStatusCode.Success &&
        changeStatusBtnTitle.nextStatus !== cockpitStatus
      ) {
        message.success(`成功切换${changeStatusBtnTitle.title}状态`);
      }
    } catch (e) {}
  };

  const handleClickChangeStatus = (e: any) => {
    e.stopPropagation();
    if (
      changeStatusBtnTitle.nextAccept === AcceptIssueStatus.STOP &&
      changeStatusBtnTitle.nextStatus === CockpitStatus.WORK
    ) {
      showModal({
        width: 400,
        content: '待全部工单结单后，您的座席将变为休息状态',
        footer: {
          showCancel: true,
          showOk: true,
          cancelFunc: (cb) => {
            cb();
          },
          okFunc: (cb) => {
            changeStatus();
            cb();
          },
        },
      });
    } else {
      changeStatus();
    }
  };

  const changeStatusBtn = () => {
    return (
      <div
        className={classNames('change-status-btn', {
          rest: cockpitStatus === CockpitStatus.REST,
        })}
      >
        <div className='left'>
          <span
            className={classNames('work-time', {
              rest: cockpitStatus === CockpitStatus.REST,
            })}
          >
            {totalWorkTime}
          </span>
          <span>今日工作时长</span>
        </div>
        <div
          className={classNames('right', {
            widen:
              cockpitStatus === CockpitStatus.WORK &&
              issueList &&
              issueList.length > 0 &&
              acceptIssueStatus === AcceptIssueStatus.ACCEPT,
          })}
          onMouseEnter={() => changeBtnHover(true)}
          onMouseLeave={() => changeBtnHover(false)}
          onClick={(e) => {
            handleClickChangeStatus(e);
          }}
          clstag={changeStatusBtnTitle.clstag}
        >
          <div
            className={classNames('btn-icon', {
              work: cockpitStatus === CockpitStatus.WORK,
              rest: cockpitStatus === CockpitStatus.REST,
              isHover: isHover,
            })}
          ></div>
          <span>{changeStatusBtnTitle.title}</span>
        </div>
      </div>
    );
  };

  return (
    <>
      {show ? (
        <div
          className='switch-cockpit-board'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <div className='header'>
            <div className='select-mode'>
              <span>模式选择&nbsp;&nbsp;</span>
              <SelectMode
                direction='down'
                curSelect={cockpitMode}
                getCurSelect={(val) => handleChangeMode(val)}
              />
            </div>
            <Button className='quit-cockpit' onClick={handleQuitCockpit}>
              退出座席模式
            </Button>
          </div>
          <div className='cockpit-info-container'>
            <div className='info'>
              <Avatar
                imgUrl={require('../../../../assets/img/cockpit/individual_avatar.png')}
              />
              <Vertical
                value={<span className='icon'>个人</span>}
                label={userName}
              />
              <Vertical
                value={currentCockpit.individualTotalNum}
                label='今日工单处理数量'
              />
              {changeStatusBtn()}
            </div>
            <div className='dividing-line'></div>
            <div className='info'>
              <Avatar
                imgUrl={require('../../../../assets/img/cockpit/team_avatar.png')}
              />
              <Vertical
                value={<span className='icon'>团队</span>}
                label={currentCockpit.cockpitTeamName}
              />
              <div style={{ position: 'relative', left: '-30px' }}>
                <Vertical
                  value={currentCockpit.teamTotalNum}
                  label='今日处理工单总数'
                />
              </div>
              <div style={{ position: 'relative', left: '-48px' }}>
                <Vertical
                  value={currentCockpit.teamPendingNum}
                  label='待处理工单数'
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default React.memo(SwitchBoard);
